import { fetchFile } from '@ffmpeg/util';

export const processVoiceEnhance = async (ffmpeg, audioFile) => {
  await ffmpeg.writeFile('input_audio', await fetchFile(audioFile));

  // The "Pro Mic" Recipe: Highpass + Bass Boost + Treble Clarity + Compand + Loudnorm
  const proFilter = "highpass=f=80,equalizer=f=100:width_type=h:w=200:g=5,equalizer=f=4000:width_type=h:w=1000:g=3,compand,loudnorm";

  await ffmpeg.exec([
    '-i', 'input_audio',
    '-af', proFilter,
    'enhanced.mp3'
  ]);

  const data = await ffmpeg.readFile('enhanced.mp3');
  return URL.createObjectURL(new Blob([data.buffer], { type: 'audio/mp3' }));
};